import { UUID } from '@builddocs/data-management'
import { useMutation } from 'react-query'

import { updateClosingNumber } from './closing.service'

export const useEditActNumber = (actId: UUID) => {
  return useMutation({
    mutationFn: ({ closingNumber }: { closingNumber: string }) =>
      updateClosingNumber({ actId, closingNumber }),
  })
}
